import { ReactNode } from "react";
import { Filter, FilterData } from "./filter";

type SelectOptionValue = string | number | boolean;

interface SelectOption {
    label: ReactNode,
    value: SelectOptionValue,
}

export interface SelectFilterProps {
    type: "select";
    name: string;
    label: string;
    initialValue?: SelectOptionValue;
    options: SelectOption[]
}

export interface SelectFilterReturn {
    type: "select";
    key: string;
    name: string;
    label: string;
    options: SelectOption[];
    value: SelectOptionValue;
    selectedOption: SelectOption | undefined;
    initialValue: SelectOptionValue;
    initialSelectedOption: SelectOption | undefined;
    active: boolean;
    getCriteria: () => string;
}

export class SelectFilter extends Filter {
    name: string;
    label: string;
    initialValue: SelectOptionValue;
    options: SelectOption[];

    initialSelectedOption: SelectOption | undefined;

    constructor({ name, label, initialValue = "", options }: SelectFilterProps) {
        super();
        this.name = name;
        this.label = label;
        this.initialValue = initialValue;
        this.options = options;

        this.initialSelectedOption = options.find(o => o.value === this.initialValue);
    }

    public getInitialValues(result: FilterData): void {
        result[this.name] = this.initialValue;
    }

    public getFilter(filterData: FilterData): SelectFilterReturn {
        const value = this.getValue(filterData);

        return {
            type: "select",
            key: this.name,
            name: this.name,
            label: this.label,
            options: this.options,
            value: value,
            initialValue: this.initialValue,
            active: value !== this.initialValue,

            initialSelectedOption: this.initialSelectedOption,
            selectedOption: this.options.find(o => o.value === value),

            getCriteria: () => this.getCriteria(filterData)
        };
    }

    public parse(filterData: FilterData, result: FilterData): void {
        const value = this.getValue(filterData);
        if (value !== this.initialValue) result[this.name] = value;
    }

    public getCriteria(filterData: FilterData): string {
        const value = this.getValue(filterData);
        const active = value !== this.initialValue;
        if (!active) return "";
        const selectedOption = this.options.find(o => o.value === value);
        return `${this.label} = ${selectedOption ? selectedOption.label : value}`
    }

    private getValue(filterData: FilterData): SelectOptionValue {
        const value = filterData[this.name];
        return value == null ? this.initialValue : value;
    }
}